angular.module('rjmNg.directives').directive "rawExport", [
  () ->
    restrict: "E"
    templateUrl: "directive.rawExport.html"
    controllerAs: 'view'
    scope: {}
    bindToController: true
    controller: [
      "$routeParams"
      "$rootScope"
      "$scope"
      "$timeout"
      "$url"
      "$modal"
      "$window"
      "app"
      "Export"
      "notification"
      "StructureCache"
      "encodedLetterString"
      (
        $routeParams
        $rootScope
        $scope
        $timeout
        $url
        $modal
        $window
        app
        Export
        notification
        StructureCache
        encodedLetterString
      ) ->

        OPERATOR_ENUMS =
          "1": "Greater Than or Equal to"
          "2": "Greater Than"
          "3": "Less Than or Equal to"
          "4": "Lees Than"
          "5": "Equal to"
          "6": "Not Equal to"
          "7": "Like"
          "8": "Is"
          "9": "Is Not"
          "10": "Not Like"
          "11": "In"
          "12": "Not In"

        ExportInstance = null
        refreshTimeoutPromise = null

        view = @
        view.isReadOnlyUser = app.isReadOnlyUser()
        view.rawExportListLoading = true
        view.exports = []
        view.encodedLetterString = encodedLetterString

        _getColumnName = (sid) ->
          return view.structure.columns[sid]?.name or "column_id: #{sid} - [DELETED]"

        _getTableName = (tableId) ->
          return view.structure.tables[tableId]?.name or "table_id: #{tableId} - [DELETED]"

        _cleanseValue = (value) ->
          replaceRules = [
            from: "\\[semicolon\\]"
            to: ";"
          ,
            from: "\\[colon\\]"
            to: ":"
          ]
          cleansedValue = value
          for rule in replaceRules
            regex = new RegExp(rule.from, 'gi');
            cleansedValue = cleansedValue.replace(regex, rule.to)

          cleansedValue

        _formatFilters = (restrictionsStr) ->
          if restrictionsStr.trim() is ""
            return []

          restrictions = restrictionsStr.split(';')
          filters = restrictions.map (restriction) ->
            [sid,op,value] = restriction.split(':')
            cleansedValue = _cleanseValue(value)

            formattedValue = switch op
              when "11", "12" then "(#{cleansedValue})"
              when "8", "9" then "[NULL]"
              else cleansedValue

            column: _getColumnName(sid)
            operation: OPERATOR_ENUMS[op]
            value: formattedValue
          filters

        _sequenceToHTML = (sequence) ->
          return if sequence then \
            sequence.replace(
              /\[/g
              "<span class='rj-form-identifier rj-form-identifier--small'>"
            ).replace(
              /\]/g
              "</span>"
            ) else null

        _addExportDefinition = (rawExport) ->
          rawExport.definition =
            tableName: _getTableName(rawExport.tableId)
            columns: rawExport.lsColumns.map((sid) -> _getColumnName(sid))
            hasFilters: rawExport.restrictionSequence?
            sequence: rawExport.restrictionSequence
            sequenceHtml: _sequenceToHTML(rawExport.restrictionSequence)
            filters: _formatFilters(rawExport.restrictions)
          rawExport

        view.refreshExportList = ->
          ExportInstance.getAllActive()
          .then (data) ->
            view.rawExportListLoading = false
            view.exports = data.map(_addExportDefinition)
            # Refresh the list 10 seconds after data is received
            refreshTimeoutPromise = $timeout(() ->
              view.refreshExportList()
            , 15000)

        view.downloadExport = (exportId) ->
          $window.open($url("/client/#{$routeParams.clientId}/export/#{exportId}/download/"), "_blank")
          return

        view.retryExport = (exportId) ->
          notification.clear("raw-exports")
          ExportInstance.retry(exportId)
          .then (result) ->
            if result
              exportObject = _(view.exports).find (exportObject) =>
                return exportObject.id is exportId
              exportObject.status = "Pending"
            else
              notification.error "Error.", "Error while retrying export id #{exportId}. Please try again or contact support.", "raw-exports"
          .catch (error) =>
            notification.error "Error.", "Error while retrying export id #{exportId}. Please try again or contact support.", "raw-exports"

        view.createNewExport = () ->
          modal = $modal
            template: 'modal.rawExport.html'
            show: true
            backdrop: 'static'
            modalClass: 'rawExportsModal'

        $rootScope.$on "rawExportQueued", () ->
          notification.clear("raw-exports")
          notification.success "Success.", "Export was successfully queued. You can view the progress and download the export below.", "raw-exports", { dismissable: true }
          $timeout.cancel(refreshTimeoutPromise)
          view.refreshExportList()

        _cleanUp = () ->
          $timeout.cancel(refreshTimeoutPromise)
          return

        $scope.$on('$destroy', _cleanUp)

        @$onInit = () ->
          notification.clear("raw-exports")
          ExportInstance = Export($routeParams.clientId)
          StructureCache.getStructure()
          .then (structure) ->
            view.structure = structure
            view.refreshExportList()

        view
    ]
]
